// Import markdown files as strings
import minimumRestPeriodMd from '../descriptions/minimum_rest_period.md?raw';
import fixedDollarMd from '../descriptions/surcharge_method/fixed_premium.md?raw';
import fixedMultiplierMd from '../descriptions/surcharge_method/offset_overtime.md?raw';
import carryOverMd from '../descriptions/surcharge_method/carry_over.md?raw';
import bumpUpMd from '../descriptions/surcharge_method/bump_up.md?raw';
import hourlyPremiumMd from '../descriptions/surcharge_method/hourly_premium.md?raw';
import multiplierFloorMd from '../descriptions/surcharge_method/guaranteed_rate.md?raw';
import surchargePeriodMd from '../descriptions/surcharge_period.md?raw';
import extendedOvertimeMd from '../descriptions/extended_overtime.md?raw';

export const surchargeMethodDescriptions = {
  fixed_dollar: fixedDollarMd,
  guaranteed_rate: multiplierFloorMd,
  offset_overtime: fixedMultiplierMd,
  carry_over: carryOverMd,
  bump_up: bumpUpMd,
  hourly_premium: hourlyPremiumMd,
} as const;

export const fieldDescriptions = {
  minimum_rest_period: minimumRestPeriodMd,
  surcharge_period: surchargePeriodMd,
  extended_overtime: extendedOvertimeMd,
} as const;

export type SurchargeMethodType = keyof typeof surchargeMethodDescriptions;
export type FieldDescriptionType = keyof typeof fieldDescriptions;
